import script from "./MediaLibraryView.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaLibraryView.vue?vue&type=script&setup=true&lang=js"

import "./MediaLibraryView.vue?vue&type=style&index=0&id=7ace527a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ace527a"]])

export default __exports__